module.exports = __webpack_public_path__ + "static/media/rush_bookmark_x_back_2x.9755d0bf.jpg";